import React from "react"
import { useDispatch } from "react-redux"
import { FaTrashAlt } from "react-icons/fa"

import { deleteComboFromOrder } from "@redux"
import { IconButton } from "components"
import classes from "./FoodComboCardHeader.module.scss"

const FoodComboCardHeader = props => {
  const { orderComboIndex } = props

  const dispatch = useDispatch()

  const handleDelete = () => {
    dispatch(
      deleteComboFromOrder(
        orderComboIndex
      )
    )
  }

  return (
    <div className={classes["header"]}>
      <IconButton
        size={22}
        icon={FaTrashAlt}
        color="var(--color-danger)"
        onClick={handleDelete}
        className={classes["button"]}
        tooltip="حذف از سبد خرید"
      />
    </div>
  )
}

export default FoodComboCardHeader